import React from 'react'
import LottiePlayer from "lottie-react";
import noquiz from '../../../assets/animationicons/quiz.json';

const NoQuizFound = () => {
    return (
        <>
            <div className="noquizfound text-center">
                <LottiePlayer
                    animationData={noquiz}
                    style={{ height: 230 }}
                    autoplay
                    loop
                />
                <h5 className='mt-3'>No Quiz Found</h5>
            </div>
        </>
    )
}

export default NoQuizFound
